import { styled } from "@mui/system"
import { Dialog, Box, Typography, IconButton, Button } from "@mui/material"

export const StyledDuplaConfirmacao = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    width: "442px",
    background: "#272D42",
    borderRadius: "0px",
  },
}))

export const Header = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "24px",
  paddingBottom: 0,
  marginBottom: "24px",
}))

export const Title = styled(Typography)(() => ({
  color: "#FFF",
  fontFamily: "Titillium Web",
  fontWeight: 400,
  fontSize: "24px",
  lineHeight: "37px",
}))

export const CloseButton = styled(IconButton)(() => ({
  width: "38px",
  height: "38px",
  color: "#E3A404",
}))

export const ContentText = styled(Typography)(() => ({
  color: "#FFF",
  fontFamily: "Titillium Web",
  fontSize: "14px",
  lineHeight: 1.6,
  marginBottom: "50px",
}))

export const Footer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
  padding: "0 24px 24px 24px",
}))

export const FooterButton = styled(Button)(() => ({
  border: "1px solid #FFF",
  borderRadius: "40px",
  padding: "4px 14px",
  color: "#FFF",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  textTransform: "uppercase",
  fontFamily: "Titillium Web",
  fontSize: "14px",
}))
